// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keyboard-wrapper-box {
  padding: 1rem;
  background: #f9fafb;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.keyboard-wrapper-box::-webkit-scrollbar {
  width: 8px;
}

.keyboard-wrapper-box::-webkit-scrollbar-track {
  background: transparent;
}

.keyboard-wrapper-box::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.keyboard-wrapper-box::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.keyboard-shortcuts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.25rem;
}

.shortcuts-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.shortcuts-card-header {
  background: #111827;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.shortcuts-card-title {
  color: #ffffff !important;
  font-size: 0.813rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
}

.shortcuts-card-body {
  padding: 0.25rem 0;
}

.shortcut-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  gap: 0.75rem;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.12s ease;
}

.shortcut-row:last-child {
  border-bottom: none;
}

.shortcut-row:hover {
  background: #f9fafb;
}

.shortcut-name {
  font-size: 0.813rem;
  color: #374151;
  font-weight: 400;
  flex: 1;
  min-width: 0;
}

.shortcut-keys {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.key-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-bottom: 2px solid #9ca3af;
  border-radius: 5px;
  padding: 2px 7px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #1f2937;
  font-family: inherit;
  line-height: 1.4;
  white-space: nowrap;
  min-width: 22px;
  text-align: center;
}

.key-separator {
  font-size: 0.7rem;
  color: #9ca3af;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 768px) {
  .keyboard-wrapper-box {
    padding: 1rem;
  }
  .keyboard-shortcuts-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .keyboard-wrapper-box {
    padding: 0.75rem;
  }
  .shortcut-row {
    padding: 0.45rem 0.75rem;
  }
  .shortcuts-card-header {
    padding: 0.625rem 0.75rem;
  }
}

/* ── Dark mode ── */
.dark .keyboard-wrapper-box {
  background: #0f172a;
}

.dark .shortcuts-card {
  background: #1e293b;
  border-color: #334155;
}

.dark .shortcut-row {
  border-bottom-color: #334155;
}

.dark .shortcut-row:hover {
  background: #334155;
}

.dark .shortcut-name {
  color: #f1f5f9;
}

.dark .key-badge {
  background: #334155;
  border-color: #475569;
  border-bottom-color: #334155;
  color: #f1f5f9;
}

.dark .key-separator {
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/KeyboardShortcut/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;EACP,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".keyboard-wrapper-box {\n  padding: 1rem;\n  background: #f9fafb;\n  overflow-y: auto;\n  flex: 1;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.keyboard-wrapper-box::-webkit-scrollbar {\n  width: 8px;\n}\n\n.keyboard-wrapper-box::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.keyboard-wrapper-box::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.keyboard-wrapper-box::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.keyboard-shortcuts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.25rem;\n}\n\n.shortcuts-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.shortcuts-card-header {\n  background: #111827;\n  padding: 0.75rem 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.shortcuts-card-title {\n  color: #ffffff !important;\n  font-size: 0.813rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.02em;\n}\n\n.shortcuts-card-body {\n  padding: 0.25rem 0;\n}\n\n.shortcut-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n  gap: 0.75rem;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background 0.12s ease;\n}\n\n.shortcut-row:last-child {\n  border-bottom: none;\n}\n\n.shortcut-row:hover {\n  background: #f9fafb;\n}\n\n.shortcut-name {\n  font-size: 0.813rem;\n  color: #374151;\n  font-weight: 400;\n  flex: 1;\n  min-width: 0;\n}\n\n.shortcut-keys {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.key-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-bottom: 2px solid #9ca3af;\n  border-radius: 5px;\n  padding: 2px 7px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: inherit;\n  line-height: 1.4;\n  white-space: nowrap;\n  min-width: 22px;\n  text-align: center;\n}\n\n.key-separator {\n  font-size: 0.7rem;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .keyboard-wrapper-box {\n    padding: 1rem;\n  }\n  .keyboard-shortcuts-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .keyboard-wrapper-box {\n    padding: 0.75rem;\n  }\n  .shortcut-row {\n    padding: 0.45rem 0.75rem;\n  }\n  .shortcuts-card-header {\n    padding: 0.625rem 0.75rem;\n  }\n}\n\n/* ── Dark mode ── */\n.dark .keyboard-wrapper-box {\n  background: #0f172a;\n}\n\n.dark .shortcuts-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .shortcut-row {\n  border-bottom-color: #334155;\n}\n\n.dark .shortcut-row:hover {\n  background: #334155;\n}\n\n.dark .shortcut-name {\n  color: #f1f5f9;\n}\n\n.dark .key-badge {\n  background: #334155;\n  border-color: #475569;\n  border-bottom-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .key-separator {\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
